import { SelectFolderAddressDialogStore } from './select-folder-address-dialog.store';
import { fb, routeParams } from '../../../../../shared/shared.global-service';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { BaseDialogComponent } from '../../../../../../components/kit/base-dialog/base-dialog.component';
import { SelectInputComponent } from '../../../../../../components/kit/input/select-input/select-input.component';
import { Validators } from '@angular/forms';
import { isInvalid } from '../../../../../shared/helpers/validate';
import { contentGlobalSuccess } from '../../../../content.error';
import { FormatAddressPipe } from '../../../../../shared/pipes/format-address.pipe';

@Component({
    selector: 'app-select-folder-address-dialog',
    templateUrl: './select-folder-address-dialog.component.html',
    styleUrl: './select-folder-address-dialog.component.scss',
    providers: [SelectFolderAddressDialogStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        SelectInputComponent,
        FormatAddressPipe,
    ]
})
export class SelectFolderAddressDialogComponent extends BaseDialogComponent {

    public readonly store = inject(SelectFolderAddressDialogStore);

    protected form = fb.group({
        address: fb.control<number | null>(null, Validators.required),
    });

    constructor() {
        super();
        this.dialogConfig.data.address && this.form.patchValue({
            address: this.dialogConfig.data.address?.id,
        });
    }

    public override async save(_event: Event): Promise<void> {
        if (isInvalid(this.form)) return;

        await this.store.api.folderSelectServiceAddress({
            folderId: Number(routeParams.folderId()),
            addressId: this.form.value.address!,
        });
        contentGlobalSuccess.next('common.updated');
        this.dialogRef.close(true);
    }

}
